import { render, staticRenderFns } from "./productUnitComponent.vue?vue&type=template&id=42425672&scoped=true&"
import script from "./productUnitComponent.vue?vue&type=script&lang=js&"
export * from "./productUnitComponent.vue?vue&type=script&lang=js&"
import style0 from "./productUnitComponent.vue?vue&type=style&index=0&id=42425672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42425672",
  null
  
)

export default component.exports